import React, { useState } from 'react'
import { ImagePicker, Toast } from 'antd-mobile'
import { uploadFile } from '@feedback/services/index'
import { useRequest } from 'ahooks'
import { getTextByKey } from '@feedback/utils/util'

interface Props {
  form?: any
  formKey?: string
}

const UploadPicture: React.FC<Props> = ({ form, formKey }) => {
  const [uploadFiles, setUploadFile] = useState<any[]>([])
  const imgLength = 3 //上传的自定义图片的长度3
  const { loading, run } = useRequest(uploadFile, {
    manual: true,
    onSuccess: (result, params) => {
      const { data, code } = result
      if (code === 0) {
        setFormValue(data.upload_key)
        setUploadFile(params[0].files)
      }
    },
    onError: (error, params) => {
      let filesArr = params.length > 0 ? params[0].files : []
      if (filesArr.length > 0) {
        Toast.offline(getTextByKey('network error'), 3)
      }
    }
  })
  const setFormValue = (key: string) => {
    if (form?.setFieldsValue && formKey) {
      form.setFieldsValue({ [formKey]: key })
    }
  }
  const onChangeTriggerMobile = (files: any[]) => {
    if (files.length) {
      run({
        files: files.length > imgLength ? files.slice(0, imgLength) : files
      })
    } else {
      setUploadFile([])
      setFormValue('')
    }
  }
  return (
    <div className='c-upload'>
      <ImagePicker
        files={uploadFiles}
        length={imgLength}
        onChange={onChangeTriggerMobile}
        accept='image/png,image/jpg,image/jpeg,image/gif'
        selectable={uploadFiles.length < 3}
        multiple={true}
      />
      {/* capture='camera' */}
    </div>
  )
}

export default UploadPicture
